import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import EmployeeSelect from '../components/EmployeeSelect';
import { getNodeApiUrl } from '../config/api.config';
import { createPortal } from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay, faCalendarWeek, faCalendarAlt, faCalendarPlus, faLayerGroup, 
         faUserGroup, faTrash, faPencil, faSave, faPlus, faTimes, 
         faClock, faHourglassStart, faHourglassEnd, faFilter, faArrowsAlt, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RightModal from '../components/templates/RightModal';
import { closeModal, selectRightModalIsOpen, selectRightModalmode, selectRightModalData, setModal } from '../redux/rightModalSlice';
import Select from 'react-select';
import { selectAccountData } from '../redux/main/accountSlice';
import AbsenceOffcanvas from '../components/absences/AbsenceOffcanvas';

// Import di FullCalendar
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

// Import CSS per il calendario
import '/src/styles/calendar.css';

// Stile CSS personalizzato unificato che funziona in tutte le viste
const GradientStyle = `
  /**********************************************
   * STILE PROFESSIONALE PER CONTROLLI DI NAVIGAZIONE
   **********************************************/
  /* Pulsanti di navigazione e intestazione */
  .fc-header-toolbar {
    padding: 8px 16px !important;
    margin-bottom: 0 !important;
  }

  /* Titolo centrale */
  .fc-toolbar-title {
    font-size: 1.5rem !important;
    font-weight: 600 !important;
    color: #374151 !important;
  }

  /* Pulsanti di navigazione (prev/next) */
  .fc-prev-button, .fc-next-button {
    background-color: #f3f4f6 !important;
    border: 1px solid #e5e7eb !important;
    box-shadow: none !important;
    color: #4b5563 !important;
    padding: 0.4rem 0.8rem !important;
    margin: 0 4px !important;
    transition: all 0.2s !important;
    border-radius: 6px !important;
  }
  
  .fc-prev-button:hover, .fc-next-button:hover {
    background-color: #e5e7eb !important;
    color: #111827 !important;
  }

  /* Pulsanti di visualizzazione (month, week, day, list) */
  .fc-button-group {
    box-shadow: none !important;
    overflow: hidden !important;
    border-radius: 6px !important;
    border: 1px solid #e5e7eb !important;
  }
  
  .fc-button-group .fc-button {
    background-color: #ffffff !important;
    border: none !important;
    box-shadow: none !important;
    color: #4b5563 !important;
    padding: 0.4rem 1rem !important;
    transition: all 0.2s !important;
  }

  .fc-button-group .fc-button:not(:last-child) {
    border-right: 1px solid #e5e7eb !important;
  }

  .fc-button-group .fc-button-active {
    background-color: #6366f1 !important;
    color: white !important;
  }

  .fc-button-group .fc-button:hover:not(.fc-button-active) {
    background-color: #f3f4f6 !important;
    color: #111827 !important;
  }

  /**********************************************
   * RESET COMPLETO STILI FULLCALENDAR
   **********************************************/
  /* Elimina il punto bianco nella vista mese */
  .fc-daygrid-event-dot {
    display: none !important;
  }
  
  /* Imposta tutti gli eventi a blocco */
  .fc-h-event, .fc-v-event, .fc-daygrid-event, .fc-timegrid-event {
    display: block !important;
    border-width: 2px !important; 
  }
  
  /* Forza il colore anche nei contenitori esterni */
  .fc-daygrid-event, .fc-timegrid-event {
    background-color: var(--event-color) !important;
    border-color: var(--event-color) !important;
  }
  
  /* Vista mensile - evento a blocco */
  .fc-daygrid-day-events .fc-daygrid-event {
    background-color: var(--event-color) !important;
    border-color: var(--event-color) !important;
    margin: 2px 0 !important;
    padding: 2px !important;
  }
  
  /* Rimuovi il colore di sfondo bianco */
  .fc-daygrid-event .fc-event-main,
  .fc-timegrid-event .fc-event-main,
  .fc-timegrid-event .fc-event-main-frame {
    background-color: transparent !important;
    color: white !important;
  }
  
  /* Fix specifico per vista mensile */
  .fc-daygrid-block-event .fc-event-time,
  .fc-daygrid-block-event .fc-event-title {
    color: white !important;
    font-weight: 400 !important;
  }
  
  /* Fix specifico per vista giornaliera e settimanale */
  .fc-timegrid-event .fc-event-main-frame {
    padding: 2px 4px !important;
  }
  
  .fc-timegrid-event .fc-event-time,
  .fc-timegrid-event .fc-event-title {
    color: white !important;
    font-weight: 400 !important;
  }
  
  /* Mantieni lo stesso colore del testo in hover */
  .fc-event:hover .fc-event-main,
  .fc-event:hover .fc-event-time,
  .fc-event:hover .fc-event-title {
    color: white !important;
  }
  
  /* Stile per i gradienti */
  .gradient-event {
    background-image: var(--gradient-bg) !important;
    background-color: transparent !important;
  }
  
  .fc-event.gradient-event .fc-event-main,
  .fc-daygrid-event.gradient-event .fc-event-main,
  .fc-timegrid-event.gradient-event .fc-event-main {
    background-image: var(--gradient-bg) !important;
    background-color: transparent !important;
  }
  
  /* Stile per quando un evento non ha utenti assegnati */
  .fc-event.no-users {
    background-color: #f3f4f6 !important;
    border-color: #d1d5db !important;
  }
  
  .fc-event.no-users .fc-event-main,
  .fc-event.no-users .fc-event-time,
  .fc-event.no-users .fc-event-title {
    color: #6b7280 !important;
  }
  
  /* Assicurati che tutti gli eventi siano visibili e non tagliati */
  .fc-daygrid-day-events {
    max-height: none !important; /* Rimuove l'altezza massima */
    overflow: visible !important; /* Permette il contenuto di superare i confini */
  }

  /* Visualizzazione tooltip */
  .has-tooltip {
    cursor: pointer;
  }
`;

// Inserisci lo stile nella pagina
function insertGradientStyle() {
  const styleId = 'fullcalendar-gradient-style';
  if (!document.getElementById(styleId)) {
    const styleElement = document.createElement('style');
    styleElement.id = styleId;
    styleElement.textContent = GradientStyle;
    document.head.appendChild(styleElement);
    return () => {
      const element = document.getElementById(styleId);
      if (element) document.head.removeChild(element);
    };
  }
}

// Funzione per aggiungere stili globali che risolvono il problema dei dropdown
function applyGlobalSelectStyles() {
  const styleId = 'select-zindex-fix';
  if (!document.getElementById(styleId)) {
    const styleElement = document.createElement('style');
    styleElement.id = styleId;
    styleElement.textContent = `
      /* Stile per garantire che i dropdown siano sempre sopra altri elementi */
      body div[role="listbox"],
      body .css-26l3qy-menu {
        z-index: 9999 !important;
      }
      
      /* Corregge problema z-index per i controlli dropdown di react-select */
      body .select__menu {
        z-index: 9999 !important;
      }
      
      /* Stili specifici per Select2 */
      body .select2-dropdown {
        z-index: 9999 !important;
      }
      
      body .select2-container--open {
        z-index: 9998 !important;
      }
      
      /* Stile speciale per i selettori nel calendario */
      .calendar-select__menu {
        z-index: 9999 !important;
      }
      
      .calendar-select__control {
        min-height: 38px !important;
        border-color: #ced4da !important;
      }
      
      .calendar-select__control:hover {
        border-color: #a1a1a1 !important;
      }
      
      .calendar-select__control--is-focused {
        box-shadow: 0 0 0 1px #2684FF !important;
        border-color: #2684FF !important;
      }
      
      /* Stili per il portale del menu */
      #select-menu-portal {
        z-index: 9999 !important;
      }
    `;
    document.head.appendChild(styleElement);
  }
}

// Componente wrapper per i dropdown che garantisce che siano sempre sopra altri elementi
function SelectOverlay({ isOpen, onClose }) {
  if (!isOpen) return null;
  
  return createPortal(
    <div 
      style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 100 }}
      onClick={onClose}
    />,
    document.body
  );
}

// Componente wrapper che gestisce i dropdown e garantisce che siano sempre sopra altri elementi
function DropdownWrapper({ children }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  // Monitora quando il dropdown viene aperto/chiuso
  const handleMenuOpen = () => {
    setIsMenuOpen(true);
  };
  
  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };
  
  useEffect(() => {
    // Quando il menu è aperto, assicurati che sia visibile
    if (isMenuOpen) {
      const portalId = 'select-menu-portal';
      let portalElement = document.getElementById(portalId);
      
      if (!portalElement) {
        portalElement = document.createElement('div');
        portalElement.id = portalId;
        portalElement.style.position = 'relative';
        portalElement.style.zIndex = '9999';
        document.body.appendChild(portalElement);
      }
    }
  }, [isMenuOpen]);
  
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      position: 'absolute'
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999
    }),
    control: (provided) => ({
      ...provided,
      zIndex: 1
    })
  };
  
  // Clona il componente figlio e passa le props necessarie
  return React.cloneElement(children, {
    onMenuOpen: handleMenuOpen,
    onMenuClose: handleMenuClose,
    styles: customStyles,
    menuPortalTarget: document.body,
    menuPosition: 'fixed'
  });
}

// Stili in-line per il layout verticale
const styles = {
    calendarContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        minHeight: 'calc(100vh - 160px)' // Altezza minima per evitare compressione eccessiva
    },
    planningPanel: {
        backgroundColor: '#ffffff',
        borderRadius: '0.5rem',
        padding: '1rem',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '1rem'
    },
    filtersContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        alignItems: 'center',
        flexWrap: 'wrap',
        maxWidth: '100%'
    },
    filterGroup: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '8px',
        height: 'auto',
        width: '100%'
    },
    calendarSection: {
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: '500px' // Altezza minima per il calendario
    },
    calendarCard: {
        flex: '1 1 auto',     // Permette alla card di crescere per occupare lo spazio disponibile
        backgroundColor: '#ffffff',
        borderRadius: '0.5rem',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        overflow: 'hidden'
    },
    cardHeader: {
        padding: '1rem',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    cardTitle: {
        margin: 0,
        fontSize: '1.25rem',
        fontWeight: '600',
        color: '#111827'
    },
    calendarContent: {
        padding: '1rem',
        height: '100%',
        minHeight: '500px'
    },
    button: {
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0.5rem 1rem',
        borderRadius: '0.375rem',
        fontSize: '0.875rem',
        fontWeight: '500',
        color: '#ffffff',
        backgroundColor: '#3182ce',
        cursor: 'pointer',
        border: 'none',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
    },
    primaryButton: {
        backgroundColor: '#3182ce',
        ':hover': {
            backgroundColor: '#2c5282'
        }
    },
    successButton: {
        backgroundColor: '#48bb78',
        ':hover': {
            backgroundColor: '#38a169'
        }
    },
    dangerButton: {
        backgroundColor: '#e53e3e',
        ':hover': {
            backgroundColor: '#c53030'
        }
    }
};

const EmployeeAbsencesCalendar = () => {
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const modalIsOpen = useSelector(selectRightModalIsOpen);
    const modalMode = useSelector(selectRightModalmode);
    const modalData = useSelector(selectRightModalData);
    const accountData = useSelector(selectAccountData);
    
    // Stati per calendario e selezioni
    const [isLoading, setIsLoading] = useState(true);
    const [calendarInstance, setCalendarInstance] = useState(null);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [selectedTypes, setSelectedTypes] = useState([]);
    
    // Stati per la gestione dell'offcanvas delle assenze
    const [offcanvasOpen, setOffcanvasOpen] = useState(false);
    const [currentAbsence, setCurrentAbsence] = useState(null);
    const [initialDate, setInitialDate] = useState(null); // Data iniziale per nuova assenza da click su giorno
    
    // Stati per la modale di conferma drag and drop
    const [dragConfirmModalOpen, setDragConfirmModalOpen] = useState(false);
    const [pendingDragEvent, setPendingDragEvent] = useState(null);
    
    // Ottiene i tipi di assenza dalle impostazioni dell'account
    const [absenceTypes, setAbsenceTypes] = useState([]);
    
    // Effetto per caricare e aggiornare i tipi di assenza quando accountData cambia
    useEffect(() => {
        if (accountData?.settings?.employeeAbsenceTypes) {
            console.log('📋 Dati originali dei tipi di assenza:', accountData.settings.employeeAbsenceTypes);
            
            const formattedTypes = accountData.settings.employeeAbsenceTypes.map(type => ({
                id: type.code, // Codice per compatibilità
                _id: type._id,  // ID MongoDB del tipo assenza
                text: type.label,
                color: type.color
            }));
            console.log('💾 Tipi di assenza formattati:', formattedTypes);
            setAbsenceTypes(formattedTypes);
        }
    }, [accountData]);
    
    // Referenze per il calendario e le sue API
    const calendarRef = useRef(null);
    const calendarApiRef = useRef(null);
    
    // Funzione per formattare la data in formato ISO (YYYY-MM-DD)
    const formatDateToISO = (date) => {
        const d = new Date(date);
        return d.toISOString().split('T')[0];
    };
    
    // Carica le assenze dal server per visualizzarle nel calendario
    const fetchEmployeeAbsences = useCallback(async (info, successCallback, failureCallback) => {
        try {
            if (!accountData?._id) {
                console.error('\ud83d\udeab accountId non disponibile');
                failureCallback('accountId non disponibile');
                return;
            }
            const accountId = accountData._id;

            const start = formatDateToISO(info.start);
            const end = formatDateToISO(info.end);

            let url = getNodeApiUrl(`employeeAbsences?accountId=${accountId}&startDate=${start}&endDate=${end}`);

            // Filtro per dipendenti selezionati
            if (selectedEmployees && selectedEmployees.length > 0) {
                const employeeIds = selectedEmployees.map(emp => emp.value).join(',');
                url += `&userId=${employeeIds}`;
            }

            // Filtro per tipi di assenza selezionati
            if (selectedTypes && selectedTypes.length > 0) {
                const absenceTypeIds = selectedTypes.map(type => type.value).join(',');
                url += `&absenceType=${absenceTypeIds}`;
            }

            console.log(`\u2705 Richiesta assenze dal ${start} al ${end}`);

            const token = localStorage.getItem('installamelo-auth-token');
            if (!token) {
                console.error('Token di autenticazione non disponibile');
                failureCallback('Token di autenticazione non disponibile');
                return;
            }

            // Log per debug
            console.log('Token utilizzato:', token.substring(0, 15) + '...');
            console.log('URL completa richiesta:', url);

            const response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': token
                }
            });

            // Log della risposta per debug
            console.log('Status risposta:', response.status);


            if (response.data && response.data.success) {
                const absences = response.data.data;
                console.log(`\u2705 Ricevute ${absences.length} assenze`);

                // Mapping icone Phosphor per tipo di assenza
                const absenceIconClasses = {
                    'ferie': 'ph-duotone ph-sun-horizon',
                    'malattia': 'ph-duotone ph-thermometer',
                    'permesso': 'ph-duotone ph-clipboard-text',
                    'infortunio': 'ph-duotone ph-first-aid-kit',
                    'maternità': 'ph-duotone ph-baby',
                    'paternità': 'ph-duotone ph-baby',
                    'lutto': 'ph-duotone ph-flower-lotus',
                    'congedo': 'ph-duotone ph-calendar-blank',
                    'aspettativa': 'ph-duotone ph-pause-circle',
                    'formazione': 'ph-duotone ph-graduation-cap',
                    'default': 'ph-duotone ph-user-minus'
                };
                
                // Trasforma le assenze in eventi per il calendario
                const events = absences.map(absence => {
                    // Usa il colore dell'utente restituito dall'API
                    const eventColor = absence.userColor || '#7367f0';
                    
                    // Determina l'icona in base al tipo di assenza
                    const absenceTypeLower = (absence.absenceType || '').toLowerCase();
                    const iconClass = absenceIconClasses[absenceTypeLower] || absenceIconClasses['default'];
                    
                    // Calcola il colore del testo in base alla luminosità del colore di sfondo
                    const hexToRgb = (hex) => {
                        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
                        return result ? {
                            r: parseInt(result[1], 16),
                            g: parseInt(result[2], 16),
                            b: parseInt(result[3], 16)
                        } : { r: 0, g: 0, b: 0 };
                    };
                    const rgb = hexToRgb(eventColor);
                    const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
                    const textColor = luminance > 0.5 ? '#000000' : '#ffffff';
                    
                    // Converti colore in rgba per trasparenza sfondo
                    const hexToRgba = (hex, alpha) => {
                        const r = parseInt(hex.slice(1, 3), 16);
                        const g = parseInt(hex.slice(3, 5), 16);
                        const b = parseInt(hex.slice(5, 7), 16);
                        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
                    };
                    const bgColorWithAlpha = hexToRgba(eventColor, 0.7);

                    // Preserviamo le stringhe ISO originali per il passaggio all'offcanvas
                    const startStr = absence.start;
                    const endStr = absence.end;
                    
                    // Log di debug per le date originali
                    console.log('\ud83d\udcc5 Date originali assenza:', {
                        id: absence._id,
                        start: startStr,
                        end: endStr,
                        timezoneDiff: absence.timezoneDiff
                    });
                    
                    return {
                        id: absence._id,
                        title: `${absence.userLabel}: ${absence.absenceType.charAt(0).toUpperCase() + absence.absenceType.slice(1)}`,
                        start: absence.start,
                        end: absence.end,
                        allDay: false, // Impostiamo a false per rispettare gli orari
                        extendedProps: {
                            absenceId: absence._id,
                            userId: absence.userId,
                            userLabel: absence.userLabel,
                            absenceType: absence.absenceType,
                            absenceTypeId: absence.absenceTypeId,
                            notes: absence.notes,
                            approved: absence.approved,
                            files: absence.files,
                            // Aggiungiamo le date originali e il timezoneDiff
                            _startStr: startStr,
                            _endStr: endStr,
                            timezoneDiff: absence.timezoneDiff,
                            userColor: eventColor,
                            iconClass: iconClass
                        },
                        backgroundColor: bgColorWithAlpha,
                        borderColor: eventColor,
                        textColor: textColor,
                        classNames: ['employee-absence']
                    };
                });

                successCallback(events);
            } else {
                console.error('\u274c Errore nel caricamento delle assenze:', response.data);
                failureCallback('Errore nel caricamento delle assenze');
            }
        } catch (error) {
            console.error('\u274c Errore nella richiesta delle assenze:', error);

            // Gestione specifica degli errori di autenticazione
            if (error.response && error.response.status === 401) {
                console.error('Errore di autenticazione (401). Il token potrebbe non essere valido.');
                failureCallback('Errore di autenticazione. Prova a riaccedere al sistema.');
            } else {
                failureCallback('Errore nella richiesta delle assenze: ' + (error.message || 'Errore sconosciuto'));
            }
        }
    }, [selectedEmployees, accountData?._id]);

    // Visualizza i dettagli dell'assenza quando si clicca sull'evento
    const handleEventClick = useCallback((info) => {
        const { event } = info;
        
        // Stampiamo tutte le proprietà disponibili nell'evento per debug
        console.log('🧐 Dati completi evento calendario:', event);
        console.log('📊 Extended Props:', event.extendedProps);
        
        // Recuperiamo i dati originali dell'assenza, inclusi i timestamp ISO originali e timezoneDiff
        const eventData = {
            _id: event.id,
            title: event.title,
            // Usiamo le proprietà _startStr e _endStr che contengono le date ISO originali se disponibili
            start: event.extendedProps._startStr || event.startStr || event.start,
            end: event.extendedProps._endStr || event.endStr || event.end,
            timezoneDiff: event.extendedProps.timezoneDiff || 120, // Default a 120 (GMT+2) se non specificato
            userId: event.extendedProps.userId,
            userLabel: event.extendedProps.userLabel,
            absenceType: event.extendedProps.absenceType,
            absenceTypeId: event.extendedProps.absenceTypeId,
            notes: event.extendedProps.notes,
            approved: event.extendedProps.approved,
            // Includiamo eventuali altre proprietà utili
            files: event.extendedProps.files || []
        };
        
        console.log('🔄 Dati passati all\'offcanvas:', eventData);

        // Apriamo l'offcanvas in modalità modifica
        setCurrentAbsence(eventData);
        setOffcanvasOpen(true);
    }, []);


    // Gestione della creazione di nuove assenze
    const handleNewAbsence = () => {
        setCurrentAbsence(null); // Reset dell'assenza corrente
        setInitialDate(null); // Reset data iniziale
        setOffcanvasOpen(true); // Apri l'offcanvas in modalità inserimento
    };
    
    // Gestione click su un giorno del calendario per creare assenza
    const handleDateClick = useCallback((info) => {
        console.log('📅 Click su giorno:', info.dateStr);
        setCurrentAbsence(null); // Nuova assenza
        setInitialDate(info.dateStr); // Imposta la data cliccata
        setOffcanvasOpen(true);
    }, []);
    
    // Gestione drag and drop di un'assenza
    const handleEventDrop = useCallback((info) => {
        console.log('🔄 Drag evento:', {
            eventId: info.event.id,
            oldStart: info.oldEvent.start,
            newStart: info.event.start,
            delta: info.delta
        });
        
        // Salva l'evento pendente e apri la modale di conferma
        setPendingDragEvent({
            event: info.event,
            oldEvent: info.oldEvent,
            revert: info.revert,
            delta: info.delta
        });
        setDragConfirmModalOpen(true);
    }, []);
    
    // Conferma spostamento assenza
    const confirmDragDrop = async () => {
        if (!pendingDragEvent) return;
        
        const { event } = pendingDragEvent;
        
        try {
            const token = localStorage.getItem('installamelo-auth-token');
            if (!token) {
                throw new Error('Token di autenticazione non disponibile');
            }
            
            // Calcola le nuove date mantenendo gli orari originali
            const newStart = event.start;
            const newEnd = event.end;
            
            // Costruisci il payload per l'aggiornamento
            const updatePayload = {
                userId: event.extendedProps.userId,
                userLabel: event.extendedProps.userLabel,
                absenceType: event.extendedProps.absenceType,
                absenceTypeId: event.extendedProps.absenceTypeId,
                start: newStart.toISOString(),
                end: newEnd.toISOString(),
                timezoneDiff: event.extendedProps.timezoneDiff || new Date().getTimezoneOffset() * -1,
                notes: event.extendedProps.notes || '',
                accountId: accountData._id
            };
            
            console.log('📤 Aggiornamento assenza:', updatePayload);
            
            const response = await axios.put(
                getNodeApiUrl(`/employeeAbsences/${event.id}`),
                updatePayload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': token
                    }
                }
            );
            
            if (response.data && response.data.success) {
                toast.success('Assenza spostata con successo');
                // Ricarica gli eventi
                if (calendarInstance) {
                    calendarInstance.refetchEvents();
                }
            } else {
                throw new Error(response.data?.message || 'Errore durante lo spostamento');
            }
        } catch (error) {
            console.error('❌ Errore spostamento assenza:', error);
            toast.error(`Errore: ${error.response?.data?.message || error.message || 'Errore sconosciuto'}`);
            // Annulla lo spostamento visivo
            pendingDragEvent.revert();
        } finally {
            setDragConfirmModalOpen(false);
            setPendingDragEvent(null);
        }
    };
    
    // Annulla spostamento assenza
    const cancelDragDrop = () => {
        if (pendingDragEvent) {
            pendingDragEvent.revert();
        }
        setDragConfirmModalOpen(false);
        setPendingDragEvent(null);
    };

    // Funzione per caricare i dati di un'assenza specifica per la modifica
    const loadAbsenceForEdit = useCallback(async (absenceId) => {
        try {
            console.log('🔍 Caricamento assenza per modifica:', absenceId);
            const response = await axios.get(
                getNodeApiUrl(`employeeAbsences/${absenceId}`),
                {
                    headers: {
                        'auth-token': localStorage.getItem('installamelo-auth-token')
                    }
                }
            );
            
            if (response.data && response.data.success) {
                console.log('✅ Assenza caricata:', response.data.data);
                setCurrentAbsence(response.data.data);
                setOffcanvasOpen(true);
                
                // Rimuovi il parametro edit dall'URL dopo aver caricato i dati
                const newSearchParams = new URLSearchParams(searchParams);
                newSearchParams.delete('edit');
                setSearchParams(newSearchParams, { replace: true });
            } else {
                console.error('❌ Errore nel caricamento dell\'assenza:', response.data);
                toast.error('Errore nel caricamento dei dati dell\'assenza');
            }
        } catch (error) {
            console.error('❌ Errore nella richiesta di caricamento assenza:', error);
            toast.error('Errore nel caricamento dell\'assenza');
        }
    }, [searchParams, setSearchParams]);

    // Gestione del parametro edit dall'URL
    useEffect(() => {
        const editParam = searchParams.get('edit');
        if (editParam && accountData && accountData._id) {
            console.log('🔗 Parametro edit trovato nell\'URL:', editParam);
            loadAbsenceForEdit(editParam);
        }
    }, [searchParams, accountData, loadAbsenceForEdit]);

    const calendarOptions = useCallback(() => {
        // Option reference: https://fullcalendar.io/docs/initialization
        return {
            plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay'
            },
            initialView: 'dayGridMonth',
            editable: true, // Abilita drag and drop
            selectable: true,
            eventClick: handleEventClick,
            dateClick: handleDateClick, // Click su giorno per creare assenza
            eventDrop: handleEventDrop, // Gestione drag and drop
            locale: 'it',
            firstDay: 1, // Lunedì come primo giorno della settimana
            eventSources: accountData?._id ? [
                {
                    events: fetchEmployeeAbsences
                }
            ] : [],
            eventTimeFormat: {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            },
            slotLabelFormat: {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            },
            slotMinTime: '07:00:00',
            slotMaxTime: '20:00:00',
            eventDidMount: function(info) {
                // Aggiungi tooltip con informazioni sull'assenza
                if (window.bootstrap && window.bootstrap.Tooltip) {
                    const tooltip = new window.bootstrap.Tooltip(info.el, {
                        title: info.event.title,
                        placement: 'top',
                        trigger: 'hover',
                        container: 'body'
                    });

                    // Aggiungi classe per indicare che l'elemento ha un tooltip
                    info.el.classList.add('has-tooltip');
                }
            },
            eventWillUnmount: function(info) {
                // Rimuovi eventuali tooltip quando gli eventi vengono smontati
                if (window.bootstrap && window.bootstrap.Tooltip) {
                    const tooltipInstance = window.bootstrap.Tooltip.getInstance(info.el);
                    if (tooltipInstance) {
                        tooltipInstance.dispose();
                    }
                }
            },
            dayHeaderFormat: { weekday: 'short', day: 'numeric' },
            // Override per il rendering degli eventi con colore utente e icona Phosphor
            eventContent: (info) => {
                // Usa il colore dell'utente salvato nell'evento
                const userColor = info.event.extendedProps.userColor || info.event.backgroundColor || '#7367f0';
                const textColor = info.event.textColor || '#ffffff';
                const iconClass = info.event.extendedProps.iconClass || 'ph-duotone ph-user-minus';
                
                // Converti colore in rgba per trasparenza sfondo
                const hexToRgba = (hex, alpha) => {
                    if (!hex || !hex.startsWith('#')) return `rgba(115, 103, 240, ${alpha})`;
                    const r = parseInt(hex.slice(1, 3), 16);
                    const g = parseInt(hex.slice(3, 5), 16);
                    const b = parseInt(hex.slice(5, 7), 16);
                    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
                };
                const bgColorWithAlpha = hexToRgba(userColor, 0.7);
                
                // Ritorniamo un elemento con icona Phosphor e colore utente
                return {
                    html: `<div class="fc-event-main-frame employee-absence" style="background-color: ${bgColorWithAlpha}; border-color: ${userColor};">
                           <div class="fc-event-title-container" style="color: ${textColor};">
                             <div class="fc-event-title fc-sticky" style="font-weight: normal;">
                               <i class="${iconClass}" style="margin-right: 5px; font-size: 14px;"></i>${info.event.title}
                             </div>
                           </div>
                         </div>`
                };
            }
        };
    }, [fetchEmployeeAbsences, accountData?._id, handleEventClick, handleDateClick, handleEventDrop]);

    // Inizializza il calendario
    useEffect(() => {
        // Inserisci gli stili CSS necessari
        insertGradientStyle();
        applyGlobalSelectStyles();

        // Se calendarRef.current è null o non abbiamo accountData._id, non inizializzare il calendario
        if (!calendarRef.current || !accountData?._id) return;

        // Inizializza il calendario
        const calendar = new Calendar(calendarRef.current, calendarOptions());
        calendar.render();

        // Salva l'istanza per l'uso successivo
        setCalendarInstance(calendar);
        setIsLoading(false);

        return () => {
            calendar.destroy();
        };
    }, [calendarRef, calendarOptions]);

    // Effetto per ricaricare il calendario quando cambiano i filtri
    useEffect(() => {
        if (calendarInstance) {
            // Ricarica gli eventi se il calendario è già inizializzato
            calendarInstance.refetchEvents();
        }
    }, [selectedEmployees, selectedTypes, calendarInstance]);

    // Renderizza il componente calendario
    return (
        <div className="container-fluid py-4">
            {/* Pannello filtri e pulsanti */}
            <div className="row px-4 mb-4">
                <div className="col-12">
                    <div className="card border shadow-sm rounded-lg overflow-hidden">
                        <div className="card-header d-flex justify-content-between align-items-center bg-white p-4 border-bottom">
                            {/* Filtri a sinistra */}
                            <div style={styles.filtersContainer}>
                                <div style={styles.filterGroup}>
                                    {/* Filtro per dipendenti */}
                                    <div className="position-relative" style={{ minWidth: '300px', zIndex: 3 }}>
                                        <label className="form-label mb-1 text-gray-600 fw-medium">Dipendenti</label>
                                        <DropdownWrapper>
                                            <EmployeeSelect 
                                                selectedOptions={selectedEmployees}
                                                setSelectedOptions={(selected) => {
                                                    setSelectedEmployees(selected || []);

                                                    // Aggiorna il calendario con il filtro dipendenti applicato
                                                    if (calendarInstance) {
                                                        console.log(`🔄 RICARICO EVENTI CALENDARIO dopo cambio dipendenti`);
                                                        calendarInstance.refetchEvents();
                                                    }
                                                }}
                                                isMulti={true}
                                                placeholder="Seleziona dipendenti..."
                                                classNamePrefix="calendar-select"
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                            />
                                        </DropdownWrapper>
                                    </div>

                                    {/* Filtro per tipi di assenza */}
                                    <div className="position-relative" style={{ minWidth: '300px', zIndex: 2 }}>
                                        <label className="form-label mb-1 text-gray-600 fw-medium">Tipi di Assenza</label>
                                        <DropdownWrapper>
                                            <Select
                                                value={selectedTypes}
                                                onChange={(selected) => {
                                                    setSelectedTypes(selected || []);

                                                    // Aggiorna il calendario con il filtro tipi applicato
                                                    if (calendarInstance) {
                                                        console.log(`🔄 RICARICO EVENTI CALENDARIO dopo cambio tipi di assenza`);
                                                        calendarInstance.refetchEvents();
                                                    }
                                                }}
                                                options={absenceTypes}
                                                isMulti={true}
                                                placeholder="Seleziona tipi di assenza..."
                                                classNamePrefix="calendar-select"
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                getOptionLabel={(option) => option.text}
                                                getOptionValue={(option) => option.id}
                                            />
                                        </DropdownWrapper>
                                    </div>
                                </div>
                            </div>

                            {/* Pulsante Nuova Assenza a destra */}
                            <div>
                                <button 
                                    className="d-flex align-items-center justify-content-center rounded-lg px-4 py-2 text-white font-medium transition-all shadow-sm hover:shadow-md"
                                    style={{
                                        backgroundColor: '#48bb78',
                                        border: 'none',
                                        fontSize: '0.95rem',
                                        letterSpacing: '0.01em'
                                    }}
                                    onClick={handleNewAbsence}
                                >
                                    <FontAwesomeIcon icon={faCalendarPlus} className="me-2" />
                                    Nuova Assenza
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Calendario principale */}
            <div className="row px-4 pb-4">
                <div className="col-12">
                    <div className="card border shadow-sm rounded-lg overflow-hidden">
                        <div className="card-header d-flex justify-content-between align-items-center bg-white py-3 px-4 border-bottom">
                            <div>
                                <h5 className="mb-0 font-semibold text-gray-800">Calendario Assenze</h5>
                            </div>
                        </div>
                        <div id="main-calendar-content" className="card-body p-0" style={{minHeight: '600px'}}>
                            {isLoading && (
                                <div className="d-flex justify-content-center align-items-center" style={{height: '100%'}}>
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Caricamento...</span>
                                    </div>
                                </div>
                            )}
                            {/* Aggiungiamo un wrapper al calendario per uno stile personalizzato */}
                            <div className="calendar-wrapper p-2">
                                <div ref={calendarRef} style={{height: '100%', minHeight: '600px'}}></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Offcanvas per l'aggiunta/modifica delle assenze */}
            <AbsenceOffcanvas 
                isOpen={offcanvasOpen}
                onClose={() => {
                    setOffcanvasOpen(false);
                    setInitialDate(null); // Reset data iniziale alla chiusura
                }}
                absenceData={currentAbsence}
                initialDate={initialDate}
                onSuccess={() => {
                    // Ricarica gli eventi dopo il salvataggio/eliminazione
                    if (calendarInstance) {
                        calendarInstance.refetchEvents();
                    }
                    setInitialDate(null); // Reset data iniziale
                }}
                absenceTypes={absenceTypes}
            />
            
            {/* Modale di conferma per drag and drop */}
            <Modal isOpen={dragConfirmModalOpen} toggle={cancelDragDrop} centered size="md">
                <ModalHeader toggle={cancelDragDrop} className="border-0 pb-0">
                    <div className="d-flex align-items-center">
                        <div className="rounded-circle bg-primary bg-opacity-10 p-3 me-3">
                            <FontAwesomeIcon icon={faArrowsAlt} className="text-primary" size="lg" />
                        </div>
                        <span className="fw-semibold">Conferma Spostamento</span>
                    </div>
                </ModalHeader>
                <ModalBody className="pt-2">
                    {pendingDragEvent && (
                        <div className="py-3">
                            <p className="mb-3 text-muted">
                                Stai per spostare l'assenza:
                            </p>
                            <div className="bg-light rounded-3 p-3 mb-3">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="ph-duotone ph-user me-2 text-primary"></i>
                                    <strong>{pendingDragEvent.event.extendedProps?.userLabel || 'Dipendente'}</strong>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <i className="ph-duotone ph-clipboard-text me-2 text-secondary"></i>
                                    <span>{pendingDragEvent.event.extendedProps?.absenceType || 'Tipo assenza'}</span>
                                </div>
                            </div>
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="text-center flex-fill">
                                    <small className="text-muted d-block mb-1">Da</small>
                                    <div className="fw-semibold text-danger">
                                        {pendingDragEvent.oldEvent?.start?.toLocaleDateString('it-IT', { 
                                            weekday: 'short', 
                                            day: '2-digit', 
                                            month: 'short' 
                                        })}
                                    </div>
                                </div>
                                <div className="px-3">
                                    <FontAwesomeIcon icon={faArrowsAlt} className="text-muted" />
                                </div>
                                <div className="text-center flex-fill">
                                    <small className="text-muted d-block mb-1">A</small>
                                    <div className="fw-semibold text-success">
                                        {pendingDragEvent.event?.start?.toLocaleDateString('it-IT', { 
                                            weekday: 'short', 
                                            day: '2-digit', 
                                            month: 'short' 
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </ModalBody>
                <ModalFooter className="border-0 pt-0">
                    <Button color="light" onClick={cancelDragDrop} className="px-4">
                        Annulla
                    </Button>
                    <Button color="primary" onClick={confirmDragDrop} className="px-4">
                        <FontAwesomeIcon icon={faSave} className="me-2" />
                        Conferma Spostamento
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default EmployeeAbsencesCalendar;
